import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const SessionStorageKeys = {
  redirectAfterLogin: 'authRedirectUrl',
} as const;

export type SessionStorageKey = (typeof SessionStorageKeys)[keyof typeof SessionStorageKeys];

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  readonly #platformId = inject(PLATFORM_ID);

  public get(key: SessionStorageKey): string | null {
    if (!isPlatformBrowser(this.#platformId)) {
      return null;
    }
    return sessionStorage.getItem(key);
  }

  public set(key: SessionStorageKey, value: string): void {
    if (!isPlatformBrowser(this.#platformId)) {
      return;
    }
    sessionStorage.setItem(key, value);
  }

  public remove(key: SessionStorageKey): void {
    if (!isPlatformBrowser(this.#platformId)) {
      return;
    }
    sessionStorage.removeItem(key);
  }

  public getAndRemove(key: SessionStorageKey): string | null {
    const value = this.get(key);
    if (value !== null) {
      this.remove(key);
    }
    return value;
  }
}
